var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-ignore
import React from "react";
// @ts-ignore
import SvgIcon from "@mui/material/SvgIcon";
var ShareIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { d: "M10 5v1.799L8.5 6.8a1.7 1.7 0 0 0-1.694 1.553L6.8 8.5v7a1.7 1.7 0 0 0 1.553 1.694l.147.006h7a1.7 1.7 0 0 0 1.694-1.553l.006-.147V11H19v4.5a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 5 15.5v-7A3.5 3.5 0 0 1 8.5 5H10Zm5.942.051a.166.166 0 0 1 .24 0l2.404 2.478c.225.232.352.547.352.876 0 .684-.538 1.238-1.2 1.238l-1.438.03c-2.92 0-5.286 1.876-5.286 4.89v.6a.173.173 0 0 1-.17.175H9.485a.172.172 0 0 1-.17-.175v-.6c0-3.981 3.126-6.642 6.984-6.642l.234-.03-1.552-1.601a.18.18 0 0 1 0-.248Z", fill: "currentColor", "fill-rule": "evenodd", "fill-opacity": ".86" }))); };
export default ShareIcon;
